module.exports = __webpack_public_path__ + "img/delete_temp.697dc472.svg";